/* tslint:disable */
require('./TextRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_ab4e6c49',
  relative: 'relative_ab4e6c49',
  fieldRendererText: 'fieldRendererText_ab4e6c49',
  fabricIcon: 'fabricIcon_ab4e6c49',
  isTruncated: 'isTruncated_ab4e6c49',
  truncate: 'truncate_ab4e6c49',
};

export default styles;
/* tslint:enable */